import { render, staticRenderFns } from "./balloon-toggle.vue?vue&type=template&id=8fbada72&"
import script from "./balloon-toggle.vue?vue&type=script&lang=js&"
export * from "./balloon-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports